import React, { useContext } from "react";
import SOBilledContent from "./SOBilledContent";
import SalesOrderDetails from "./SalesOrderDetails";
import mainContext from "../context/MainContext/mainContext";

const BilledSalesOrder = () => {
  const { id } = useContext(mainContext);

  return <>{id ? <SalesOrderDetails /> : <SOBilledContent />}</>;
};

export default BilledSalesOrder; 